import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/Rules.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/configurations/rules`;
	}
	get(e, t, n) {
		return this.api.get(r(e, t, n));
	}
	create(e) {
		return this.api.post(n.baseUrl, e);
	}
	update(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, t);
	}
	delete(e, t, n) {
		return this.api.delete(r(e, t, n));
	}
}, r = (e, t, r) => [
	n.baseUrl,
	e.toUpperCase(),
	t.toUpperCase(),
	r
].join("/");
//#endregion
export { n as Rules };

//# sourceMappingURL=Rules.js.map